import {NgModule} from '@angular/core';
import {WorkObservationsService} from './work-observations.service';

/**
 * Created by Rodrigo Quesada on 24/11/16.
 */
@NgModule({
    providers: [
        WorkObservationsService
    ]
})
export class WorkObservationsModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/work/observations/work-observations.module.ts